const initialState = {
  dateChanged: true,
  athleteAccountId: "",
  gymAcountId: "",
  gymData: [],
  userData: {},
  workoutApiCalled: 0,
  trackInfo: [],
  userUpdated: 0,
  trackChanged: 0,
  gymList: [],
  selectedGym: 0,
  selectedAthlete: {},  
  isDupilicate: false,
  connectedAccountId: '',
  newMessageNotifications: false,
  newNonMessageNotifications: false
};

export default initialState;
